import React, { forwardRef } from "react";

export const Checkbox = forwardRef(({ ariaLabel, onToggle }, ref) => {
  return (
    <input
      ref={ref}
      type="checkbox"
      className="mailchimp-group-toggle"
      aria-label={ariaLabel}
      onChange={onToggle}
    />
  );
});
